import * as React from 'react';
import DatePicker from "react-datepicker";
import moment from 'moment';
import { injectIntl, useIntl } from 'react-intl';
import { TranslateText } from '../TranslateText';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export let DropdownValue = /*#__PURE__*/function (DropdownValue) {
  DropdownValue["Day"] = "Day";
  DropdownValue["Week"] = "Week";
  DropdownValue["Month"] = "Month";
  DropdownValue["Quarter"] = "Quarter";
  DropdownValue["Year"] = "Year";
  DropdownValue["Custom"] = "Custom";
  return DropdownValue;
}({});

// PropType definition

;

// Header component with props and its types
const _DateFilter = props => {
  const {
    title,
    options,
    value: inputValue,
    onTriggerChange,
    dateFormat
  } = props;
  const [selectedOption, setSelectedOption] = React.useState("");
  const [dateFilterFlag, setDateFilterFlag] = React.useState(false);
  const [startDate, setStartDate] = React.useState("");
  const [endDate, setEndDate] = React.useState("");
  const [toggle, setToggle] = React.useState(false);
  const [dropdownBottom, setDropdownBottom] = React.useState(false);
  const intl = useIntl();

  //dropdown custom value naming labels section
  const custom = options.find(item => item.value === DropdownValue.Custom);
  const fromLabel = custom ? custom.fromLabel : '';
  const toLabel = custom ? custom.toLabel : '';
  const fromPlaceHolder = custom ? custom.fromPlaceholder : '';
  const toPlaceHolder = custom ? custom.toPlaceholder : '';
  const minDate = custom ? custom.min : '';
  const maxDate = custom ? custom.max : '';
  const ref = React.useRef();
  const calculateDropdownBottom = () => {
    if (!ref || !ref.current) return;
    const AVG_OPTION_HEIGHT = 50;
    const windowHeight = window.innerHeight;
    const menuHeight = options.length * AVG_OPTION_HEIGHT;
    const instOffsetWithMenu = ref.current.getBoundingClientRect().bottom + menuHeight;
    setDropdownBottom(instOffsetWithMenu >= windowHeight);
  };
  React.useEffect(() => {
    const checkIfClickedOutside = e => {
      // If the menu is open and the clicked target is not within the menu,
      // then close the menu
      if (toggle && ref.current && !ref.current.contains(e.target)) {
        setToggle(false);
      }
    };
    document.addEventListener("mousedown", checkIfClickedOutside);
    return () => {
      // Cleanup the event listener
      document.removeEventListener("mousedown", checkIfClickedOutside);
    };
  }, [toggle]);
  React.useEffect(() => {
    calculateDropdownBottom();
    document.addEventListener('resize', calculateDropdownBottom);
    document.addEventListener('scroll', calculateDropdownBottom);
    return () => {
      // Cleanup the event listener
      document.removeEventListener('resize', calculateDropdownBottom);
      document.removeEventListener('scroll', calculateDropdownBottom);
    };
  }, [options]);
  const handleOptionChange = option => {
    setSelectedOption(option.value);
    setToggle(false);
    if (option.value === DropdownValue.Custom) {
      setDateFilterFlag(true);
      setStartDate("");
      setEndDate("");
    } else {
      setDateFilterFlag(false);
    }
    handleDateInput(option.value, "", "");
  };
  const handleDateInput = (value, fromDate, toDate) => {
    const currentDate = new Date();
    const dayStart = moment(currentDate).startOf('day').toDate();
    const monthStart = moment(currentDate).startOf('month').toDate();
    const weekStart = moment(currentDate).startOf('week').add('days', 1).toDate();
    const quarterStart = moment(currentDate).startOf('quarter').toDate();
    const yearStart = moment(currentDate).startOf('year').toDate();
    const mappingDateValues = {
      "Day": {
        "fromDate": dayStart,
        "toDate": currentDate
      },
      "Week": {
        "fromDate": weekStart,
        "toDate": currentDate
      },
      "Month": {
        "fromDate": monthStart,
        "toDate": currentDate
      },
      "Quarter": {
        "fromDate": quarterStart,
        "toDate": currentDate
      },
      "Year": {
        "fromDate": yearStart,
        "toDate": currentDate
      },
      "Custom": {
        "fromDate": fromDate,
        "toDate": toDate
      }
    };
    if (onTriggerChange) {
      onTriggerChange({
        data: {
          value,
          fromDate: mappingDateValues[value].fromDate,
          toDate: mappingDateValues[value].toDate
        }
      });
    }
  };
  React.useEffect(() => {
    const {
      value,
      fromDate,
      toDate
    } = inputValue;
    const valueSelected = options.filter(item => item.value === value);
    if (valueSelected.length) {
      setSelectedOption(value);
      if (value === DropdownValue.Custom) {
        setDateFilterFlag(true);
        setStartDate(fromDate);
        setEndDate(toDate);
      } else {
        setDateFilterFlag(false);
      }
    } else {
      options.length ? setSelectedOption(options[0].value) : '';
      setDateFilterFlag(false);
    }
  }, [props]);
  const handleChangeStartDate = date => {
    setStartDate(date);
    handleDateInput(selectedOption, date, endDate);
  };
  const handleChangeEndDate = date => {
    setEndDate(date);
    handleDateInput(selectedOption, startDate, date);
  };
  const selectedOptionValue = options?.length ? options.find(i => i.value === selectedOption)?.label : selectedOption;
  const dropdownBotomAlignmentClassname = dropdownBottom ? 'kc-ui-datefilter-bottom-alignment' : '';
  const days = ['KC2086', 'KC2087', 'KC2088', 'KC2089', 'KC2090', 'KC2091', 'KC2092'];
  const months = ['KC2047', 'KC2048', 'KC2049', 'KC2050', 'KC2051', 'KC2052', 'KC2053', 'KC2054', 'KC2055', 'KC2056', 'KC2057', 'KC2058'];
  const datePickerLocale = {
    localize: {
      day: n => intl.formatMessage({
        id: days[n]
      }),
      month: n => intl.formatMessage({
        id: months[n]
      })
    },
    formatLong: {}
  };
  return /*#__PURE__*/_jsx(React.Fragment, {
    children: /*#__PURE__*/_jsx("div", {
      className: 'kc-ui-colm kc-ui-datefilter',
      children: /*#__PURE__*/_jsx("div", {
        className: `kc-ui-colm-div-dd ${title && !dateFilterFlag ? 'kc-ui-div-dd-align' : ''}`,
        children: /*#__PURE__*/_jsxs("div", {
          className: "kc-ui-dd-wrapper",
          children: [/*#__PURE__*/_jsxs("div", {
            className: "kc-ui-dropdown",
            children: [title && /*#__PURE__*/_jsx("p", {
              className: "kc-ui-date-filter-title",
              children: /*#__PURE__*/_jsx(TranslateText, {
                id: title
              })
            }), /*#__PURE__*/_jsxs("div", {
              className: "kc-ui-datefilter-wrapper",
              ref: ref,
              children: [/*#__PURE__*/_jsx("button", {
                className: "kc-ui-dd-select-button",
                onClick: () => setToggle(oldState => !oldState),
                children: /*#__PURE__*/_jsx(TranslateText, {
                  id: selectedOptionValue
                })
              }), toggle && /*#__PURE__*/_jsx("ul", {
                className: `${title && !dateFilterFlag ? 'kc-ui-isdaterange' : title && dateFilterFlag ? 'kc-ui-title-isdaterange' : dateFilterFlag ? 'kc-ui-isdaterange' : ''} ${dropdownBotomAlignmentClassname} `,
                children: options && options.length && typeof options ? options.map((option, index) => {
                  return /*#__PURE__*/_jsxs("li", {
                    className: option.value === DropdownValue.Custom ? `kc-ui-date-range` : '',
                    onClick: () => handleOptionChange(option),
                    value: inputValue.value,
                    children: [option.value === DropdownValue.Custom && /*#__PURE__*/_jsx("span", {
                      className: "kc-ui-date-range-icon"
                    }), /*#__PURE__*/_jsx(TranslateText, {
                      id: option.label
                    })]
                  }, index);
                }) : null
              })]
            })]
          }), dateFilterFlag && /*#__PURE__*/_jsxs("div", {
            className: "kc-ui-dd-flag",
            children: [fromLabel && /*#__PURE__*/_jsx("h6", {
              className: "kc-ui-dd-from",
              children: /*#__PURE__*/_jsx(TranslateText, {
                id: fromLabel
              })
            }), /*#__PURE__*/_jsx(DatePicker, {
              locale: datePickerLocale,
              className: "kc-ui-dd-filter",
              dateFormat: dateFormat,
              selected: startDate,
              minDate: minDate,
              maxDate: endDate || maxDate,
              value: startDate,
              placeholderText: fromPlaceHolder ? intl.formatMessage({
                id: fromPlaceHolder
              }) : '',
              onChange: handleChangeStartDate,
              showMonthDropdown: true,
              showYearDropdown: true,
              dropdownMode: "select"
            }), toLabel && /*#__PURE__*/_jsx("h6", {
              className: "kc-ui-dd-to",
              children: /*#__PURE__*/_jsx(TranslateText, {
                id: toLabel
              })
            }), /*#__PURE__*/_jsx(DatePicker, {
              locale: datePickerLocale,
              className: "kc-ui-dd-filter",
              dateFormat: dateFormat,
              selected: endDate,
              minDate: startDate,
              maxDate: maxDate,
              value: endDate,
              placeholderText: toPlaceHolder ? intl.formatMessage({
                id: toPlaceHolder
              }) : '',
              onChange: handleChangeEndDate,
              showMonthDropdown: true,
              showYearDropdown: true,
              dropdownMode: "select"
            })]
          })]
        })
      })
    })
  });
};

// Prop type definition for compile time

// Default props
_DateFilter.defaultProps = {
  title: "",
  options: [],
  value: {},
  onTriggerChange: () => {},
  dateFormat: "MM/dd/yyyy"
};
export const DateFilter = injectIntl( /*#__PURE__*/React.memo(_DateFilter));